import { useAuthStore } from "~/stores/auth.store";

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const authStore = useAuthStore();

  if (_to.query.isWebview) authStore.setIsWebview();
});
